





























import {MyStudyChoiceOnboardingModelState} from "@/apps/MyStudyChoiceOnboardingWidget/models/store-viewmodel"
import {defineComponent} from "@vue/composition-api"
import {useActions, useGetters} from "vuex-composition-helpers"
import {leave} from "@/apps/MyStudyChoiceOnboardingWidget/composables/transition"
import {ActionTree, GetterTree} from "vuex"
import NavigationBulletAtom from "@/shared/components/atoms/NavigationBulletAtom.vue"

export default defineComponent({
    name: "SubscribeStep",
    components: {NavigationBulletAtom},
    props: {
        reverse: {
            type: Boolean,
            required: true
        }
    },
    setup: () => {
        const {getLabels, getActiveStep, getActiveSubStepIndex} = useGetters<GetterTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'getLabels', 'getActiveStep', 'getActiveSubStepIndex'
        ])
        const {setCanContinue, setNextStep, setPreviousStep} = useActions<ActionTree<MyStudyChoiceOnboardingModelState, MyStudyChoiceOnboardingModelState>>([
            'setCanContinue', 'setNextStep', 'setPreviousStep'
        ])
        setCanContinue(true)

        function navigate(index: number, transition: string) {
            if(index === getActiveSubStepIndex.value) return
            if(index > getActiveSubStepIndex.value) {
                setNextStep()
            } else {
                setPreviousStep()
            }
        }

        return {
            getLabels,
            setCanContinue,
            getActiveStep,
            getActiveSubStepIndex,
            navigate,
            leave
        }
    }
})
